import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.setupIcons();
  }

  setupIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'file-list',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/file-list.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'heart-positive',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/heart-positive.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'restaurant',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/restaurant.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'restaurant-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/restaurant-gray.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'capsule',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/capsule.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'medicine-bottle',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/medicine-bottle.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'syringe',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/syringe.svg')
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'admin',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/admin.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'auxiliary',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/auxiliary.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'integration',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/integration.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'home',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/home.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'technical-note',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/technical-note.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'medication',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/medication.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'procedure',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/procedure.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'health-product',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/health-product.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'nutritional-product',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/nutritional-product.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'produtos-nutricionais-comerciais',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/produtos-nutricionais-comerciais.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'cosmetic',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/cosmetic.svg'
      )
    );

    this.matIconRegistry.addSvgIconInNamespace(
      'main-menu',
      'dot-mark',
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'assets/icons/menu/dot-mark.svg'
      )
    );

    this.matIconRegistry.addSvgIcon(
      'heart-positive-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/heart-positive-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'medication-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/medication-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'attention-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/attention-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'bank-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/bank-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'mask-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/mask-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'capsule-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/capsule-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'dolar-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/dolar-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'file-list-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/file-list-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'files-gray',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/gray/files-gray.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'red-eye-outline',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/red/red-eye-outline.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'red-sheet-outline',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/red/red-sheet-outline.svg')
    );

    this.matIconRegistry.addSvgIcon(
      'historico-solicitacoes',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/icons/solicitar-informacoes/historico.svg')
    );

  }
}
